export var unprotected = Symbol();